import { Component, OnInit, OnDestroy, EventEmitter, ViewChild } from '@angular/core';
import { UploadStatus } from 'ngx-uploader-esb';
import { MatLegacyTabGroup as MatTabGroup } from '@angular/material/legacy-tabs';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

import { PlaylistItemsService } from '../../core/services/http-services/playlistItems.service';
import { LaunchersService } from '../../core/services/http-services/launchers.service';
import { PlaylistItemType } from '../../core/models/enums/playlist-item-type.enum';
import { Launcher } from '../../core/models/entities/launcher.type';
import { MonitorHub } from '../../shared-module/hubs/monitor.hub';
import { PlaylistDTO } from '../../core/models/view-models/playlist-models/playlist-dto.model';
import { PlaylistItemDTO } from '../../core/models/view-models/playlist-item-models/playlist-item-dto.model';
import { DeleteDialogService } from '../../core/services/dialog-services/delete-dialog.service';
import { PlaylistItemDialogService } from '../../core/services/dialog-services/playlist-item-dialog.service';
import { AddPlaylistItemsTab } from '../../core/models/view-models/playlist-models/add-playlist-items-tab.model';
import { PlaylistDialogMessagesEnum } from '../../core/enums/toastr-messages/playlist-dialog-messages.enum';

@Component({
  selector: 'playlist-item-dialog',
  templateUrl: './playlist-item-dialog.component.html',
  styleUrls: ['./playlist-item-dialog.component.scss']
})
export class PlaylistItemDialogComponent implements OnInit, OnDestroy {
  playlist: PlaylistDTO;
  oldPlaylistItems: PlaylistItemDTO[] = [];
  playlistItems: PlaylistItemDTO[] = [];
  AddAnother = false;
  closeRequest = new EventEmitter<AddPlaylistItemsTab>();
  launchers: Launcher[] = [];
  subscriptions: Subscription = new Subscription();
  @ViewChild('tabs', { static: true }) tabs: MatTabGroup;
  isForegroundTabEnabled: boolean;
  playlistHasForegroundRss: boolean

  private selectedIndex = 0;

  constructor(
    public playlistItemsService: PlaylistItemsService,
    public playlistItemDialogService: PlaylistItemDialogService,
    public monHub: MonitorHub,
    public launchersService: LaunchersService,
    private deleteDialogService: DeleteDialogService
  ) { }

  ngOnInit() {
    if (this.playlistItems?.length && this.playlistItems[0].PlaylistItemType) {
      this.oldPlaylistItems = _.cloneDeep(this.playlistItems);

      switch (this.playlistItems[0].PlaylistItemType) {
        case PlaylistItemType.Url:
          this.tabs.selectedIndex = 2;
          break;

        case PlaylistItemType.RecentFile:
          this.tabs.selectedIndex = 0;
          break;

        case PlaylistItemType.LocalFile:
          this.tabs.selectedIndex = 3;
          break;

        case PlaylistItemType.Foreground:
          this.tabs.selectedIndex = 4;
          break;
      }
    }

    if (!this.playlistItems?.length) {
      this.playlistItems.push(new PlaylistItemDTO());
      this.playlistItems[0].PlaylistId = this.playlist.Id;
    }

    this.subscriptions.add(
      this.launchersService.getAllGeneric().subscribe(
        (data: Launcher[]) => this.launchers = [...(data ? data.sort((a, b) => a.Id - b.Id) : []), ...(this.launchers ? this.launchers : [])]
      )
    );

    this.playlistHasForegroundRss = this.playlistItemsService.playlistHasForegroundRssItem(this.playlist);

    this.isForegroundTabEnabled = this.playlist.IsAndroid &&
      (this.playlistItems[0].PlaylistItemType === PlaylistItemType.Foreground ||
        !this.playlistItemsService.playlistHasAllForegroundItemTypes(this.playlist));
  }

  onDialogClose(isCanceled: boolean): void {
    if (isCanceled) {
      this.playlistItems.forEach((item, i) => Object.assign(item, this.oldPlaylistItems[i]));
    }

    this.closeRequest.emit(new AddPlaylistItemsTab(this.playlist.PlaylistItems, this.AddAnother));
  }

  onSelectedIndexChanged(selectedTabIndex: number): void {
    if (this.selectedIndex == PlaylistItemType.UploadFile && this.playlistItemDialogService.uploadStatus === UploadStatus.Uploading) {
      this.tabs.selectedIndex = PlaylistItemType.UploadFile;

      this.subscriptions.add(
        this.deleteDialogService.show(PlaylistDialogMessagesEnum.ChangeActiveTabInfo).subscribe((isToStopUploading: boolean) => {
          if (isToStopUploading) {
            this.tabs.selectedIndex = selectedTabIndex;
            this.playlistItemDialogService.uploadStatus = UploadStatus.Cancelled;
          }
        })
      );
    } else {
      this.tabs.selectedIndex = selectedTabIndex;
    }
    this.selectedIndex = this.tabs.selectedIndex;
    this.tabs.realignInkBar();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
